<template>
  <v-app>
    <explore-frame :partner_id="partner_id" :name="name"></explore-frame>
  </v-app>
</template>

<script>
import ExploreFrame from './views/ExploreFrame.vue'

export default {
  name: 'App',
  props: ['partner_id', 'name'],
  components: {
    exploreFrame: ExploreFrame
  },

  data: () => ({
    //
  }),
};
</script>
